'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import type { OfficeDetailsProps as OfficeDetailsComponentProps } from './OfficeDetails'
import { PhnxOfficeDetails } from './OfficeDetails'

interface LocationData {
  latitude: string
  longitude: string
}

interface OfficeDetailsProps {
  blok: {
    title?: string
    address: string
    phone: string
    hours: string
    formId: string
    form?: NonNullable<OfficeDetailsComponentProps['form']>
    location: LocationData[]
    mailingAddress: string
  } & SbBlokData
}

const OfficeDetails: FC<OfficeDetailsProps> = ({ blok }) => {
  const latToAssign = Number(blok.location[0].latitude)
  const longToAssign = Number(blok.location[0].longitude)

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxOfficeDetails
        title={blok.title}
        address={blok.address}
        phone={blok.phone}
        hours={blok.hours}
        formId={blok.formId}
        mailingAddress={blok.mailingAddress}
        location={{
          lat: latToAssign,
          long: longToAssign,
        }}
      />
    </div>
  )
}

export default OfficeDetails
